import { gerrieUpdateAccount } from "@bToC/Services/GerrieAccountService";
import { GerrieUpdateAccountModel } from "@bToC/Services/GerrieApiModels";
import { addToChainAfter, Handler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { AddAccountApiParameter, updateAccount } from "@insite/client-framework/Services/AccountService";
import {
    AddAccount,
    AddAccountParameter,
    chain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Data/Accounts/Handlers/AddAccount";
import { AccountModel } from "@insite/client-framework/Types/ApiModels";

export interface GerrieAddAccountParameter extends AddAccountParameter {
    accountInfo: GerrieUpdateAccountModel;
}

addToChainAfter(chain, AddAccount, GerriePopulateApiParameter);

async function GerriePopulateApiParameter(props: any) {
    if (props.apiResult.successful) {
        props.apiResult = await gerrieUpdateAccount(props.parameter);
    }
}

addToChainAfter(chain, PopulateApiParameter, AddAcccountModelProperties);

function AddAcccountModelProperties(props: any) {
    const accountModel = props.apiParameter.account as AccountModel;
    const accountInfo = props.parameter.accountInfo as GerrieUpdateAccountModel;

    const properties = {
        registrationAccountNumber: accountInfo.accountNumber,
        registrationInvoiceNumber: accountInfo.invoiceNumber,
        companyName:accountInfo.companyName,
        address1:accountInfo.address1,
        address2:accountInfo.address2,
        city:accountInfo.city,
        postalCode:accountInfo.postalCode,
        phoneNumber:accountInfo.phoneNumber,
        faxNumber:accountInfo.faxNumber,
        country:accountInfo.country,
        state:accountInfo.state
    };

    accountModel.properties = properties;
    accountModel.firstName = accountInfo.firstName;
    accountModel.lastName = accountInfo.lastName;

    props.apiParameter.account = accountModel;
}
